import React, {useEffect, useMemo} from "react";
import countries from "../../../../../assets/scripts/countries.json"
import useBackendUsers from "../../../../providers/mortgage/useBackendUsers";
import {
    adminProofOfAddressSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/proof-of-address/section";
import {
    adminIdentificationSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/identification/section";
import {
    adminAccountStatementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/account-statement/section";
import {legacyIncome} from "../../application-stages/_common/lender-tests/useXlsTests";
import {capitaliseFirst, capitaliseWords, wordLimit} from "../../../../../assets/scripts/string-functions";
import {
    adminCreditStatementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/credit-statement/section";
import {
    adminLoanStatementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/loan-statement/section";
import {adminPayslipSection} from "../../../../providers/mortgage/uploads/verified-upload-sections/payslip/section";
import {
    adminFinancialAccountsSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/financial-accounts/section";
import {adminForm11Section} from "../../../../providers/mortgage/uploads/verified-upload-sections/form-11/section";
import {
    adminAccountantsLetterSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/accountants-letter/section";
import {
    adminSalaryCertSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/salary-certificate/section";
import {
    ApplicationStages, ApplicationStatuses,
    BoolLike,
    BuildType,
    EmploymentBases, EmploymentTypes,
    MortgageTypes,
    PersonalMaritalStatuses, PropertyTypes
} from "../../../../../models";
import {
    adminEmploymentContractSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/employment-contract/section";
import {
    adminProofOfPPSNSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/proof-of-ppsn/section";
import {
    adminMarriageCertificateSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/marriage-certificate/section";
import {
    adminDivorceDecreeSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/divorce-decree/section";
import {
    adminSeparationAgreementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/separation-agreement/section";
import {
    adminGiftCertificateSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/gift-certificate/section";
import {
    adminBookingDepositReceiptSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/booking-deposit-receipt/section";
import {
    adminHTBSchemeFormsSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/htb-scheme-form/section";
import {
    adminEDSSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/employment-detail-summary/section";
import {
    adminResidencePermitSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/residence-permit/section";
import {
    adminCreditReportSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/credit-report/section";
import {
    adminInvestmentStatementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/investment-statement/section";
import {
    adminCriticalSkillsEmploymentPermitSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/critical-skills-employment-permit/section";
import generalSection from "../../../../providers/mortgage/uploads/verified-upload-sections/_section/section.class";
import {
    customerApprovalDocumentsToCreate
} from "../../application-stages/approval/parts/useApprovalCustomerDocumentsToGenerate";
import {
    customerPreApprovalDocumentsToCreate
} from "../../application-stages/pre-approval/useCustomerPreApprovalDocuments";
import {
    adminProofOfDepositInBankSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/proof-of-deposit-in-bank/section";
import {
    adminBusinessAccountStatementSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/business-account-statement/section";
import {
    adminHomeInsuranceSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/home-insurance/section";
import {
    adminDDBankAccountSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/dd-bank-account/section";
import {
    adminExistingMpiPolicySection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/existing-mpi-policy/section";
import useMortgage from "../../../../providers/mortgage/useMortgage";
import {
    adminBerCertificateSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/ber-certificate/section";
import dayjs from "dayjs";
import {
    adminReturnToWorkLetterSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/return-to-work-letter/section";
import {contractRequired} from "../../application/forms/sections/ApplicantEmploymentIncome";
import {
    adminBonusPayslipSection
} from "../../../../providers/mortgage/uploads/verified-upload-sections/bonus-payslips/section";
import {adminCVSection} from "../../../../providers/mortgage/uploads/verified-upload-sections/cv/section";
import {
    diagnosedConditionGroups
} from "../../application-stages/_common/mortgage-protection-insurance/diagnosedConditions";

let mortgageUploadSectionsTimout = null

function useMortgageUploadSections(mortgage) {
    const ApplyAndUpdateEverywhere = [ApplicationStages.APPLY, 'U:PREAPPROVAL', 'U:PREAPPROVAL_EXTENDING', 'U:APPROVAL', 'U:APPROVAL_EXTENDING']
    const ddBankAccountID = mortgage?.requirement?.ddBankAccountID
    const {me} = useBackendUsers()
    const request = {me}

    const isSectionIncompleteOrHasUploadsNewerThenLastPackage = (stage, section) => {
        let packagedDate = null
        switch (stage) {
            case ApplicationStages.PREAPPROVAL:
            case ApplicationStages.PREAPPROVAL_EXTENDING:
                packagedDate = mortgage?.activeSubmission?.completedFlowItems?.ApplicationSubmitted
                break
            case ApplicationStages.APPROVAL:
            case ApplicationStages.APPROVAL_EXTENDING:
                packagedDate = mortgage?.activeSubmission?.completedFlowItems?.LoanOfferSubmitted
                break
        }
        if (packagedDate) {

            packagedDate = dayjs(packagedDate)
            const newUploads = section.activeUploads.find(upload => dayjs(upload.createdAt).isAfter(packagedDate))
            if (newUploads) {
                return true
            }
        }

        return !section.isComplete
    }

    const dynamicUploads = (stage) => mortgage ? mortgage.dynamicSections.filter(item => item.sectionStage === stage).map(it => {
        let applicant = it.sectionName.endsWith('-1') || it.sectionApplicant === 1 ? 1 : it.sectionName.endsWith('-2') || it.sectionApplicant === 2 ? 2 : false
        return {
            category: 'custom',
            custom: it.id,
            applicant,
            type: 'UPLOAD',
            name: it.sectionName,
            stage: it.sectionStage,
            title: it.sectionTitle,
            index: it.sectionIndex,
            section: it.sectionName,
            children: it.description,
            upload: true,
            defaultUserStages: [it.sectionStage],
        }
    }) : []
    const APPLICATION = () => {
        const applicantUploads = (n) => {
            let address = mortgage[`applicant${n}`]?.personal?.addressCurrent
            if (mortgage.requirement.cohabiting && n === 2) {
                address = mortgage[`applicant1`].personal.addressCurrent
            }
            const uploadList = [{
                category: 'identification',
                name: 'proof-of-address',
                title: 'proof of address',
                dataType: adminProofOfAddressSection,
                adminOnly: true
            }, {
                category: 'identification',
                name: 'identification',
                title: 'identification',
                dataType: adminIdentificationSection,
                defaultUserStages: ApplyAndUpdateEverywhere
            }]
            const appIndex = 'applicant' + n
            const legacyEmployment = legacyIncome(mortgage)
            //const legacyEmployment = !mortgage[appIndex].employment.employmentType

            mortgage[appIndex].accounts.forEach(account => {
                if (!!ddBankAccountID && account.id === ddBankAccountID && mortgage.requirement.ddBankAccountIsNew) {
                    uploadList.push({
                        name: `current-accounts`,
                        title: 'Photo of your New Account Details',
                        index: account.id,
                        stage: 'APPROVAL',
                        instructions: {
                            specialRequirements: [
                                'Upload a photo of the card/welcome letter/opening statement showing Name and Account IBAN',
                                'Alternatively, upload a screenshot from online banking showing the account iban',
                            ]
                        },
                        children: 'Upload new account details',
                        isClosed: account.isClosed,
                        defaultUserStages: [ApplicationStages.APPROVAL]
                    })


                } else {
                    uploadList.push({
                        isStatement: true,
                        category: 'bank-statements',
                        name: 'current-accounts',
                        title: (account.institution || 'Current Account'),
                        index: account.id,
                        statementGroup: 'Current Accounts',
                        data: {
                            ...account, typeName: 'accounts'
                        },
                        dataType: adminAccountStatementSection,
                        defaultUserStages: [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL_EXTENDING, ApplicationStages.APPROVAL_EXTENDING]
                    })
                }
            })
            mortgage[appIndex].assets.forEach(asset => {
                let title
                // let noOfMonths = getMonthsFromRange(`assets-${n}`, asset.id)
                let isInvestment = false
                let isStatement = null
                switch (asset['assetType']) {
                    case 'SAVING':
                        title = (asset.institution || 'New') + ' savings'
                        isStatement = true
                        break
                    case 'INVESTMENT':
                        isInvestment = true
                        title = (asset.institution || asset.description || 'New') + ' investment'
                        break
                    default:
                        title = 'Unspecified Asset'
                }
                let defaultUserStages = isInvestment ? [ApplicationStages.APPLY] : [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL_EXTENDING, ApplicationStages.APPROVAL_EXTENDING]
                uploadList.push({
                    category: isInvestment ? 'other-statements' : 'bank-statements',
                    isInvestment,
                    isStatement,
                    dataType: isInvestment ? adminInvestmentStatementSection : adminAccountStatementSection,
                    statementGroup: `${capitaliseFirst((asset['assetType'] || 'New Asset').toLowerCase())} Accounts`,
                    name: 'assets',
                    title: title,
                    index: asset.id,
                    data: {
                        ...asset, typeName: 'assets'
                    },
                    defaultUserStages
                })
            })
            mortgage[appIndex].debts.forEach(debt => {

                let title = debt.lender
                let isCredit = false
                let dataType
                switch (debt['debtType']) {
                    case 'CREDITCARD':
                        title += ' credit card'
                        isCredit = true
                        dataType = adminCreditStatementSection
                        break
                    case 'STORECARD':
                        title += ' store card'
                        isCredit = true
                        dataType = adminCreditStatementSection
                        break
                    case 'LOAN':
                        title += ' loan'
                        dataType = adminLoanStatementSection
                        break
                    default:
                        title = 'Unspecified Debt'
                }

                uploadList.push({
                    category: 'other-statements',
                    name: 'debts',
                    isCredit,
                    title: title,
                    statementGroup: !debt['debtType'] ? 'Unspecified Account' : `${capitaliseFirst(debt['debtType'].toLowerCase())} Accounts`,
                    index: debt.id,
                    data: {
                        ...debt, typeName: 'debts'
                    },
                    dataType,
                    defaultUserStages: [ApplicationStages.APPLY]
                })
            })
            const noOfJobs = legacyEmployment ? 1 : mortgage[appIndex].employmentIncome.length
            const selfEmployedUploads = (job) => {
                let index = job.hasOwnProperty('incomes') ? job.id : undefined

                let jobName = job.nameOfBusiness || 'Self-Employed'
                let extraTitle = noOfJobs > 1 ? ` (${jobName})` : ''
                return [{
                    category: 'employment', name: 'payslips', title: `payslips${extraTitle}`, data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    }, index, dataType: adminPayslipSection,
                    defaultUserStages: [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL_EXTENDING, ApplicationStages.APPROVAL_EXTENDING]
                }, {
                    category: 'employment',
                    name: 'business-statements',
                    title: `business bank statements${extraTitle}`,
                    data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    },
                    dataType: adminBusinessAccountStatementSection,
                    defaultUserStages: [ApplicationStages.APPLY],
                    index
                }, {
                    category: 'employment',
                    name: 'accounts',
                    title: `financial accounts${extraTitle}`,
                    data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    }, index,
                    dataType: adminFinancialAccountsSection,
                    defaultUserStages: [ApplicationStages.APPLY],
                }, {
                    category: 'employment',
                    name: 'form11',
                    title: 'form 11 (removed for users)',
                    data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    },
                    index,
                    dataType: adminForm11Section,
                    defaultUserStages: [ApplicationStages.APPLY],
                }, {
                    category: 'employment',
                    name: 'accountant-letter',
                    title: `Accountant In Order Letter${extraTitle}`,
                    data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    },
                    index,
                    dataType: adminAccountantsLetterSection,
                    defaultUserStages: [ApplicationStages.APPLY],
                }]
            }
            const employedUploads = (job) => {

                let index = job.hasOwnProperty('incomes') ? job.id : undefined
                let list = []
                let extraTitle = noOfJobs > 1 ? ` (${job.employmentBasis})` : ''
                list.push({
                    defaultUserStages: [ApplicationStages.APPLY],
                    category: 'employment', name: 'salary-cert', title: `salary certificate${extraTitle}`, data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    }, index, dataType: adminSalaryCertSection
                }, {
                    category: 'employment', name: 'payslips', title: `payslips${extraTitle}`, // extras: [
                    data: {
                        ...job, typeName: index ? 'employmentIncome' : 'employment'
                    }, index, dataType: adminPayslipSection,
                    defaultUserStages: [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL, ApplicationStages.PREAPPROVAL_EXTENDING, ApplicationStages.APPROVAL_EXTENDING]
                })
                if (job.employmentBasis === EmploymentBases.CONTRACT || job?.contractRequired) {
                    list.push({
                        category: 'employment',
                        name: 'employment-contract',
                        title: 'Employment Contract',
                        children: 'Upload the contract you have with your employer',
                        data: {
                            ...job, typeName: index ? 'employmentIncome' : 'employment'
                        },
                        dataType: adminEmploymentContractSection,
                        index,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                }
                if (job.maternityLeave) {
                    list.push({
                        category: 'employment',
                        index: job.id,
                        name: 'return-to-work-letter',
                        title: 'Returning to Work Letter',
                        data: {
                            ...job, typeName: index ? 'employmentIncome' : 'employment'
                        },
                        dataType: adminReturnToWorkLetterSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                }
                if (mortgage?.activeSubmission?.lenderCode === 'boi' && job.publicSector && job.usingPayscale) {
                    list.push({
                        category: 'employment',
                        name: `payscale-confirmation-letter`,
                        index: job.id,
                        title: `Payscale Confirmation Letter for ${job.currentEmployerName}`,
                        children: `You need to upload a letter from ${mortgage[appIndex].strings.your} employer confirming he next two pay scales, salary at those pay scales and what dates ${mortgage[appIndex].strings.you} will advance to those pay scales`,
                        data: {
                            ...job, typeName: index ? 'employmentIncome' : 'employment'
                        },
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                }
                // if (job.usingShareSaveAmount || job.usingBikAmount || job.usingAvcAmount) {
                //     list.push({
                //         category: 'employment',
                //         name: 'historic-payslips',
                //         title: 'PRA Payslips',
                //         data: {
                //             ...job, typeName: index ? 'employmentIncome' : 'employment'
                //         },
                //         // dataType: adminEmploymentContractSection,
                //         index
                //     })
                //
                // }

                return list
            }
            const eds = () => {
                return {
                    category: 'employment',
                    name: `employment-summary`,
                    title: 'employment details summary',
                    dataType: adminEDSSection,
                    defaultUserStages: [ApplicationStages.APPLY]
                }
            }
            const form11 = () => {
                return {
                    category: 'employment',
                    name: `form11`,
                    title: 'Form 11',
                    dataType: adminForm11Section,
                    defaultUserStages: [ApplicationStages.APPLY]
                }
            }
            const chapterfour = () => {
                return {
                    category: 'employment',
                    name: `chapter-four`,
                    title: 'Chapter Four Receipts',
                    defaultUserStages: [ApplicationStages.APPLY]
                }
            }

            if (legacyEmployment) {
                switch (mortgage[appIndex].employment.employmentType) {
                    case 'EMPLOYED' :
                        if (!uploadList.find(i => i.name === `employment-summary`)) {
                            uploadList.push(eds())
                        }
                        uploadList.push(...employedUploads(mortgage[appIndex].employment))
                        break
                    case 'SELFEMPLOYED' :
                        uploadList.push(eds())
                        uploadList.push(...selfEmployedUploads(mortgage[appIndex].employment))
                        break
                    default:
                }
            } else {
                if (mortgage[appIndex].employmentIncome?.length) {
                    mortgage[appIndex].employmentIncome.forEach(job => {
                        switch (job.employmentType) {
                            case 'EMPLOYED' :
                                if (!uploadList.find(i => i.name === `employment-summary`)) {
                                    uploadList.push(eds())
                                }
                                uploadList.push(...employedUploads(job))
                                break
                            case 'SELFEMPLOYED' :
                                if (!uploadList.find(i => i.name === `employment-summary`)) {
                                    uploadList.push(eds())
                                }
                                if (!uploadList.find(i => i.name === `form11` && !i.index)) {
                                    uploadList.push(form11())
                                }
                                if (!uploadList.find(i => i.name === `chapter-four` && !i.index)) {
                                    uploadList.push(chapterfour())
                                }
                                uploadList.push(...selfEmployedUploads(job))
                                break
                            default:
                        }
                        const bonusInc = (job.incomes || []).find(inc => inc.name === "bonus")
                        if (bonusInc && ((bonusInc.yearMostRecent || 0) > 0 || (bonusInc.yearBefore || 0) > 0 || (bonusInc.yearBeforeThat || 0) > 0)) {
                            const thisYear = new Date().getFullYear()
                            const requiredYears = []
                            if (bonusInc.yearMostRecent) {
                                requiredYears.push(thisYear - 1)
                            }
                            if (bonusInc.yearBefore) {
                                requiredYears.push(thisYear - 2)
                            }
                            if (bonusInc.yearBeforeThat) {
                                requiredYears.push(thisYear - 3)
                            }

                            uploadList.push({
                                category: 'employment',
                                index: job.id,
                                name: 'bonus-payslips',
                                title: 'bonus payslips',
                                children: `Upload the payslips that show the bonus payments for ${requiredYears.length > 1 ? 'the years ' : ''}` + requiredYears.join(', '),
                                defaultUserStages: [ApplicationStages.APPLY],
                                dataType:adminBonusPayslipSection
                            })
                        }
                    })
                    const today = dayjs()
                    const threeYearsAgo = today.subtract(3, 'year')
                    const hasThreeYears = mortgage[appIndex].employmentIncome.some(job => {
                        if (![EmploymentTypes.SELFEMPLOYED, EmploymentTypes.EMPLOYED].includes(job.employmentType)) {
                            return true;
                        }
                        if (job.currentEmployerStartDate) {
                            let start = dayjs(job.currentEmployerStartDate)
                            if (start.isBefore(threeYearsAgo)) {
                                return true
                            }
                        }
                        if (!job.firstJob && job.previousEmployerStartDate) {
                            let start = dayjs(job.previousEmployerStartDate)
                            if (start.isBefore(threeYearsAgo)) {
                                return true
                            }
                        }
                        return false
                    })
                    if (!hasThreeYears) {
                        uploadList.push({
                            category: 'employment',
                            name: 'curriculum-vitae',
                            title: 'Curriculum Vitae',
                            defaultUserStages: [ApplicationStages.APPLY],
                            dataType: adminCVSection

                        })
                    }
                }
            }
            const isEmployed = uploadList.find(i => i.name === `employment-summary`)

            if (!isEmployed) {
                uploadList.push({
                    category: 'identification',
                    name: `proof-of-ppsn`,
                    title: `Proof of PPS Number (revenue or welfare document with name, address and PPSN)`,
                    dataType: adminProofOfPPSNSection,
                    defaultUserStages: [ApplicationStages.APPLY]
                })
            }

            switch (mortgage[appIndex].personal.maritalStatus) {

                case 'MARRIED':
                case 'REMARRIED':
                    // are married to eachother?
                    if (!(n === 2 && mortgage.twoApplicants && mortgage.requirement.cohabiting && ['MARRIED', 'REMARRIED'].includes(mortgage.applicant1.personal.maritalStatus))) {
                        uploadList.push({
                            category: 'certs',
                            name: 'marriage-cert',
                            title: 'marriage certificate',
                            dataType: adminMarriageCertificateSection,
                            defaultUserStages: [ApplicationStages.APPLY]
                        })
                    }
                    break
                case 'DIVORCED':
                    uploadList.push({
                        category: 'certs',
                        name: 'divorce-decree',
                        title: 'decree of divorce',
                        dataType: adminDivorceDecreeSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                    break
                case PersonalMaritalStatuses.SEPARATED:
                    uploadList.push({
                        category: 'certs',
                        name: 'separation-agreement',
                        title: 'separation agreement',
                        dataType: adminSeparationAgreementSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                    break
                default:
            }

            mortgage[appIndex].properties.forEach(property => {
                if (property.isMortgaged) {
                    let title = wordLimit(property.address || 'New property')
                    uploadList.push({
                        category: 'other-statements',
                        name: 'properties',
                        statementGroup: 'Mortgage Accounts',
                        title: title + ' mortgage',
                        relatedTo: [`properties-${n}`],
                        index: property.id,
                        data: {
                            ...property, typeName: 'properties'
                        },
                        dataType: adminLoanStatementSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                }
            })

            let answer = mortgage[appIndex].personal.nationality
            let country = !!answer ? countries.find(item => item.alpha_2_code === answer) : false
            if (!!country && !country.is_EU) {
                uploadList.push({
                    category: 'certs',
                    name: 'residence-permit',
                    title: 'Residence Permit',
                    dataType: adminResidencePermitSection,
                    defaultUserStages: ApplyAndUpdateEverywhere
                })
                if (mortgage[appIndex].personal.hasCriticalSkillsPermit) {
                    uploadList.push({
                        category: 'certs',
                        name: 'critical-skills-permit',
                        title: 'Critical Skills Employment Permit',
                        dataType: adminCriticalSkillsEmploymentPermitSection,
                        defaultUserStages: ApplyAndUpdateEverywhere
                    })
                }
            }
            if (mortgage.mortgageType === MortgageTypes.PURCHASE) {
                // credit checks if other country of residence in past 3 years or irish residence start date less than 3 years ago
                if (mortgage[appIndex].personal.otherCountryOfResidenceInPast3Years || (mortgage?.[appIndex]?.personal?.irishResidenceStartDate && dayjs(mortgage?.[appIndex]?.personal?.irishResidenceStartDate).isAfter(dayjs().subtract(3, 'year'))) || mortgage[appIndex].personal.countryOfResidence !== 'IE') {
                    const foreign = {
                        category: 'certs',
                        name: 'foreign-credit-report',
                        title: 'Foreign Credit Report',
                        dataType: adminCreditReportSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    }
                    uploadList.push(foreign)
                }
                const report = {
                    category: 'certs',
                    name: 'credit-report',
                    dataType: adminCreditReportSection,
                    title: 'Irish Credit Report (optional)',
                    defaultUserStages: [ApplicationStages.APPLY]
                }
                uploadList.push(report)
            }
            return uploadList.map(item => {
                item.applicant = n
                item.name = `${item.name}-${n}`
                item.stage = 'APPLY'
                item.type = 'UPLOAD'
                return item
            })

        }
        const mortgageUploads = () => {

            const uploadList = []
            if (mortgage.mortgageType === MortgageTypes.REFINANCE) {
                mortgage.properties.forEach(property => {
                    let title = wordLimit(property.address || 'Mortgaging property')
                    uploadList.push({
                        category: 'other-statements',
                        statementGroup: 'Mortgage Accounts',
                        name: 'mortgage-statements',
                        title: `${title} Mortgage`,
                        index: property.id,
                        dataType: adminLoanStatementSection,
                        defaultUserStages: [ApplicationStages.APPLY]
                    })
                })
            }
            if ((mortgage.property?.propertyPrice || mortgage.property?.propertyValue) <= 500000 && mortgage.property?.buildType !== BuildType.SECONDHAND && mortgage.requirement.helpToBuyScheme !== BoolLike.FALSE) {
                uploadList.push({
                    category: 'other',
                    name: 'htb-scheme-forms',
                    title: 'Help to Buy Scheme ScreenShot',
                    dataType: adminHTBSchemeFormsSection, // customExtra: <CustomHelpToBuyForm/>
                    defaultUserStages: [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL]
                })
            }

            // if (mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.property?.bookingDepositPaid) {
            //     uploadList.push({
            //         category: 'other',
            //         name: 'deposit',
            //         title: 'Booking Deposit Receipt',
            //         dataType: adminBookingDepositReceiptSection,
            //         defaultUserStages: [ApplicationStages.PREAPPROVAL, ApplicationStages.PREAPPROVAL_EXTENDING, ApplicationStages.APPROVAL, ApplicationStages.APPROVAL_EXTENDING],
            //
            //     })
            // }

            if (!!mortgage.requirement.receivingGifts) {
                uploadList.push({
                    category: 'other',
                    name: 'gift-certificate',
                    title: 'Gift Certificate',
                    dataType: adminGiftCertificateSection,
                    defaultUserStages: ['ptsb','avant','boi','haven'].includes(mortgage.activeSubmission?.lenderCode) ? [ApplicationStages.APPLY] : [ApplicationStages.APPLY, ApplicationStages.PREAPPROVAL]
                })
            }

            return uploadList.map(item => {
                return {
                    ...item, applicant: false, stage: 'APPLY', type: 'UPLOAD'
                }
            })

        }

        const uploadSectionss = applicantUploads(1)
        if (mortgage.twoApplicants) {
            uploadSectionss.push(...applicantUploads(2))
        }
        uploadSectionss.push(...mortgageUploads())
        uploadSectionss.push(...dynamicUploads('APPLY'))


        return uploadSectionss.map(item => {
            const {dataType, ...rest} = item
            if (typeof item.dataType === "string" || item.dataType == null) {
                return new generalSection(request, mortgage, item)
            }

            return new dataType(request, mortgage, rest)
        })
    }
    const PREAPPROVAL = () => {
        const items = []
        const preapprovalCustomerDocuments = customerPreApprovalDocumentsToCreate(mortgage)

        preapprovalCustomerDocuments.forEach(doc => {
            if (doc.folder === 'downloads' && !!doc.generated) {
                const item = {
                    category: 'generated',
                    name: doc.name,
                    section: doc.name,
                    title: capitaliseWords(doc.name.replace(/-/g, ' ')),
                    children: '',
                    stage: ApplicationStages.PREAPPROVAL,
                    upload: true,
                    defaultUserStages: [ApplicationStages.PREAPPROVAL, ApplicationStages.PREAPPROVAL_EXTENDING],
                }
                if (doc.dataType) {
                    item.dataType = doc.dataType
                }
                items.push(item)
            }
        })
        if (mortgage.requirement.firstHomeScheme === BoolLike.TRUE) {
            items.push({
                category: 'other',
                name: 'first-home-scheme',
                title: 'First Home Scheme Eligibility Certificate',
                children: 'When you obtain your First Home Scheme Eligibility Certificate, upload it here',
                applicant: false,
                stage: ApplicationStages.PREAPPROVAL,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
                upload: true
            })
        }
        const noOfPayslips = mortgage.activeSubmission?.lenderCode === 'boi' ? 'Two Payslips' : 'Payslip'
        items.push({
            category: 'employment',
            name: 'payslip-1',
            applicant: 1,
            title: `Most Recent ${noOfPayslips} `,
            children: `You need to upload ${mortgage.applicant1.firstName}'s most recent payslip`,
            stage: ApplicationStages.PREAPPROVAL,
            upload: true,
            defaultUserStages: ApplyAndUpdateEverywhere,
            redundant: true
        })
        if (mortgage.twoApplicants) {
            items.push({
                category: 'employment',
                name: 'payslip-2',
                applicant: 2,
                title: `Most Recent ${noOfPayslips}`,
                children: `You need to upload ${mortgage.applicant2.firstName}'s most recent payslip`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                redundant: true
            })
        }
        // const needsPreApprovalUpdating = (()=>{
        //     const a1Accounts = mortgage.applicant1.accounts.filter(ac => ac.updateAtPreApproval).map(ac=>({...ac, applicant:1}))
        //     const a1Savings = mortgage.applicant1.assets.filter(ac => ac.updateAtPreApproval).map(ac=>({...ac, applicant:1}))
        //     const a2Accounts = mortgage.twoApplicants ? mortgage.applicant2.accounts.filter(ac => ac.updateAtPreApproval).map(ac=>({...ac, applicant:2})) : []
        //     const a2Savings = mortgage.twoApplicants ? mortgage.applicant2.assets.filter(ac => ac.updateAtPreApproval).map(ac=>({...ac, applicant:2})) : []
        //     const all = [...a1Accounts, ...a1Savings, ...a2Accounts, ...a2Savings]
        //     return (all.length) > 0 ? all : false
        // })();

        const ApplicationSections = APPLICATION().filter(section => section?.data?.updateAtPreApproval)

        //if (ApplicationSections.length) {
        ApplicationSections.forEach(ac => {
            items.push({
                category: 'updated-statements',
                isInvestment: ac?.props?.isInvestment,
                isStatement: ac?.props?.isStatement,
                dataType: ac?.props?.isInvestment ? adminInvestmentStatementSection : adminAccountStatementSection,
                statementGroup: 'What goes here?', //${capitaliseFirst((asset['assetType'] || 'New Asset').toLowerCase())} Accounts`,
                name: `updated-statements-${ac.applicant}`,
                title: ac.title,
                index: ac.index,
                data: ac.data,
                applicant: ac.applicant,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                redundant: true
            })
        })
        //}
        //else{
        items.push({
            category: 'bank-statements',
            name: 'bank-statement-1',
            title: `Most Recent Bank Statement (not in user app anymore)`,
            children: `You need to upload ${mortgage.applicant1.firstName}'s most recent bank statement (into which salary is paid)`,

            applicant: 1,
            stage: ApplicationStages.PREAPPROVAL,
            upload: true,
            redundant: true
        })
        if (mortgage.twoApplicants) {
            items.push({
                applicant: 2,
                category: 'bank-statements',
                name: 'bank-statement-2',
                title: `Most Recent Bank Statement (not in user app anymore)`,
                children: `You need to upload ${mortgage.applicant2.firstName}'s most recent bank statement (into which salary is paid)`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                redundant: true
            })
        }
        //}

        if (mortgage.property?.buildType === BuildType.SELFBUILD) {
            items.push({
                category: 'other',
                name: 'construction-costings',
                title: `Construction Costings`,
                children: `You need to upload a breakdown of the construction costs for the property, showing both completed and remaining expenses`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
            })
            items.push({
                category: 'other',
                name: 'planning-permission',
                title: `Grant of Planning Permission `,
                children: `You need to upload the notification that you have been granted planning permission for the property`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
            })
            items.push({
                category: 'other',
                name: 'builders-insurance',
                title: `Builder's Insurance`,
                children: `You need to upload evidence of your builder's insurance for the property`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
            })
            items.push({
                category: 'other',
                name: 'certificate-of-inspection',
                title: `Certificate of Inspection`,
                children: `You need to upload a certificate of inspection for the property, showing who is responsible for inspections of the construction`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
            })
        } else if (mortgage.mortgageType !== MortgageTypes.REFINANCE) {
            items.push({
                category: 'other',
                name: 'deposit-receipt',
                //TODO: I think should have {index: mortgage.property.id} here, but need to check with the team
                section: 'deposit-receipt',
                title: `Receipt for Payment of Booking Deposit`,
                children: `You need to upload the receipt for the deposit you paid on the property`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                dataType: adminBookingDepositReceiptSection,
                defaultUserStages: [ApplicationStages.PREAPPROVAL, 'U:PREAPPROVAL_EXTENDING', 'U:APPROVAL', 'U:APPROVAL_EXTENDING'],
            })
        }
        if (mortgage?.property?.surveyRequired || mortgage?.property?.propertyAge === ">100"){
            items.push({
                name: 'property-survey',
                title: 'Property Survey',
                children: 'Upload a copy of the property survey, which should be completed by a qualified surveyor',
                applicant: false,
                defaultUserStages: [ApplicationStages.PREAPPROVAL]
            })
        }

        if (mortgage.mortgageType === 'PURCHASE' && mortgage?.requirement?.depositSavings) {
            items.push({
                category: 'other',
                name: 'proof-of-deposit',
                section: 'proof-of-deposit',
                title: `Proof of Deposit`,
                children: `You need to upload a statement(s) showing you have the deposit amount available`,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                dataType: adminProofOfDepositInBankSection,
                defaultUserStages: [ApplicationStages.PREAPPROVAL, 'U:PREAPPROVAL_EXTENDING', 'U:APPROVAL', 'U:APPROVAL_EXTENDING'],
            })
        }
        if (mortgage.requirement?.hasOwnMPI) {
            items.push({
                category: 'other',
                name: 'existing-mpi',
                section: 'existing-mpi',
                title: `Existing mortgage protection insurance`,
                children: `You need your existing mortgage protection insurance policy document`,
                stage: ApplicationStages.PREAPPROVAL,
                defaultUserStages: [ApplicationStages.PREAPPROVAL, ApplicationStages.APPROVAL],
                upload: true,
                applicant: false,
                dataType: adminExistingMpiPolicySection
            })
        }
        else {
            // the Royal London questionnaires for an applicant's diagnosed conditions,
            // as built in the user app (useMortgageUploads healthQuestionnaires)
            const applicantNumbers = mortgage.twoApplicants ? [1, 2] : [1]
            applicantNumbers.forEach(n => {
                const selections = mortgage[`applicant${n}`]?.health?.diagnosedConditionSelections || []
                const hasQuestionnaire = diagnosedConditionGroups.some(group => group.url && selections.includes(group.value))
                if (hasQuestionnaire) {
                    items.push({
                        category: 'other',
                        name: `health-questionnaires-${n}`,
                        section: 'health-questionnaires',
                        title: 'Diagnosed Conditions Forms',
                        children: 'Download, complete and sign the questionnaire for each condition, then upload them here',
                        stage: ApplicationStages.PREAPPROVAL,
                        defaultUserStages: [ApplicationStages.PREAPPROVAL],
                        upload: true,
                        applicant: n
                    })
                }
            })
        }
        if (![BuildType.SELFBUILD, BuildType.NEW].includes(mortgage?.property?.buildType) && mortgage?.activeSubmission?.lenderCode !== "avant" && mortgage.property?.addressKnown) {
            items.push({
                category: 'other',
                name: 'ber-certificate',
                section: 'ber-certificate',
                title: `BER Certificate`,
                children: `You need to upload a copy of your BER Certificate`,
                applicant: false,
                stage: ApplicationStages.PREAPPROVAL,
                upload: true,
                dataType: adminBerCertificateSection,
                defaultUserStages: [ApplicationStages.PREAPPROVAL],
            })
        }
        if (mortgage.activeSubmission?.lenderCode === "boi") {

            const createBoiSalaryCertItem = (n, income) => {
                let applicant = mortgage[`applicant${n}`]
                const noOfJobs = applicant.employmentIncome.length
                let extraTitle = noOfJobs > 1 ? ` (${income.currentEmployerName})` : ''
                return {
                    category: 'employment',
                    applicant: n,
                    name: `boi-salary-cert-${n}`,
                    title: `BOI salary certificate${extraTitle}`,
                    data: {
                        ...income, typeName: 'employmentIncome'
                    },
                    index: income.id,
                    dataType: adminSalaryCertSection,
                    upload: true,
                    stage: "PREAPPROVAL",
                    defaultUserStages: [ApplicationStages.PREAPPROVAL],
                }
            }
            mortgage.applicant1.employmentIncome.forEach((income) => {
                if (income.employmentType === 'EMPLOYED') {

                    items.push(createBoiSalaryCertItem(1, income))
                }
            })
            if (mortgage.twoApplicants) {
                mortgage.applicant2.employmentIncome.forEach((income) => {
                    if (income.employmentType === 'EMPLOYED') {
                        items.push(createBoiSalaryCertItem(2, income))
                    }
                })
            }


        }

        items.push(...dynamicUploads('PREAPPROVAL'))


        // add updated rsisidence permit if applicable
        const applicants = (mortgage.twoApplicants ? [1, 2] : [1])
            .filter((applicant, n) => {
                let answer = mortgage[`applicant${applicant}`]?.personal?.nationality
                let country = !!answer ? countries.find(item => item.alpha_2_code === answer) : false
                if (!!country && !country.is_EU) {
                    // neds permit
                    return true
                }
                return false
            })
        if (applicants.length) {
            const Apply = APPLICATION()

            applicants.forEach((applicant, n) => {
                const residencePermitSection = Apply.find(it => it.name === `residence-permit-${applicant}`)
                if (residencePermitSection && residencePermitSection.activeUploads.length === 0) {
                    items.push({
                        category: 'other',
                        name: `updated-residence-permit-${applicant}`,
                        section: 'updated-residence-permit',
                        title: `Updated Residence Permit`,
                        children: `You need to upload a new/replacement residence permit`,
                        stage: ApplicationStages.PREAPPROVAL,
                        defaultUserStages: ApplyAndUpdateEverywhere,
                        upload: true,
                        applicant
                    })
                }
            })
        }

        return items.map(item => {
            const {dataType, ...rest} = item
            if (typeof item.dataType === "string" || item.dataType == null) {
                const thing = new generalSection(request, mortgage, item)
                thing.setUnverifiableProblems()
                return thing
            }

            return new dataType(request, mortgage, rest)
        })

    }
    const APPROVAL = () => {
        const userCreate = mortgage.mortgageAdminDocuments.approval().user.create
        const approvalCustomerDocuments = customerApprovalDocumentsToCreate(mortgage)
        const items = []
        userCreate.forEach(doc => {
            if (doc.folder === 'downloads' && !!doc.generated) {
                const item = {
                    category: 'generated',
                    name: doc.name,
                    section: doc.name,
                    title: capitaliseWords(doc.name.replace(/-/g, ' ')),
                    children: '',
                    stage: ApplicationStages.APPROVAL,
                    upload: true,
                    defaultUserStages: [ApplicationStages.APPROVAL],
                }
                if (doc.dataType) {
                    item.dataType = doc.dataType
                }
                items.push(item)
            }
        })
        items.push(...dynamicUploads('APPROVAL'))
        if (mortgage.mortgageType === 'PURCHASE' && mortgage.requirement?.depositSavings) {
            items.push({
                category: 'other',
                name: 'proof-of-deposit',
                section: 'proof-of-deposit',
                title: `Proof of Deposit`,
                children: `You need to upload a statement(s) showing you have the funds needed to close`,
                stage: ApplicationStages.APPROVAL,
                defaultUserStages: [ApplicationStages.APPROVAL, ApplicationStages.PREAPPROVAL],
                upload: true,
                dataType: adminProofOfDepositInBankSection,
                redundant: true,
            })
        }
        if ([
            PropertyTypes.TERRACE,
            PropertyTypes.DETACHED,
            PropertyTypes.SEMIDETACHED
        ].includes(mortgage.property?.propertyType)) {
            items.push({
                category: 'property',
                name: 'letter-of-indemnity',
                section: 'letter-of-indemnity',
                title: `Home Insurance`,
                children: `You need to upload a copy of your home insurance (Letter of Indemnity), noting the lender's interest in the property`,
                applicant: false,
                stage: ApplicationStages.APPROVAL,
                upload: true,
                dataType: adminHomeInsuranceSection,
                defaultUserStages: [ApplicationStages.APPROVAL],

            })
            if (mortgage.activeSubmission?.lenderCode === 'boi') {
                // depreciate on July 2026
                items.push({
                    category: 'property',
                    name: 'home-insurance-policy',
                    section: 'home-insurance-policy',
                    title: `Policy Schedule of the Home Insurance`,
                    children: `You need to upload a copy of your Home Insurance Policy Schedule`,
                    applicant: false,
                    stage: ApplicationStages.APPROVAL,
                    upload: true,
                    defaultUserStages: [ApplicationStages.APPROVAL],
                    redundant: true,
                })
            }
        }
        // if (mortgage.activeSubmission?.lenderCode === 'haven') {
        //     items.push({
        //         category: 'property',
        //         name: 'ber-certificate',
        //         section: 'ber-certificate',
        //         title: `BER Certificate (Moved to PreApproval)`,
        //         children: `You need to upload a copy of your BER Certificate`,
        //         applicant: false,
        //         stage: ApplicationStages.APPROVAL,
        //         upload: true,
        //         redundant: true,
        //     })
        // }
        // if (mortgage.requirement.ddBankAccountID) {
        //     const account1 = mortgage.applicant1.accounts.find(a => a.id === mortgage.requirement.ddBankAccountID)
        //     const account2 = mortgage.twoApplicants ? mortgage.applicant2?.accounts?.find(a => a.id === mortgage.requirement.ddBankAccountID) : null
        //     // const progress1 = mortgage.progress.find(p => p.index === account1.id)
        //     // const progress2 = mortgage.twoApplicants ? mortgage.progress.find(p => p.index === account2?.id) : null
        //
        //     if (account1 || account2) {
        //         const n = account1 ? 1 : account2 ? 2 : 0
        //         const index = account1 ? account1.id : account2.id
        //         if (n) {
        //             items.push({
        //                 category: 'other',
        //                 name: `current-accounts-${n}`,
        //                 index,
        //                 section: 'dd-bank-account',
        //                 title: `Direct Debit Bank Account`,
        //                 children: `You need to upload a copy of the bank statement for the account you will use for your direct debit`,
        //                 stage: ApplicationStages.APPROVAL,
        //                 upload: true,
        //                 dataType: adminDDBankAccountSection,
        //                 redundant: true,
        //             })
        //         }
        //     }
        // }
        return items.map(item => {
            const {dataType, ...rest} = item
            if (typeof item.dataType === "string" || item.dataType == null) {
                const thing = new generalSection(request, mortgage, item)
                thing.setUnverifiableProblems()
                return thing
            }

            return new dataType(request, mortgage, rest)
        })
    }
    let stage = mortgage.applicationStage
    if (stage === ApplicationStages.SIGN || stage === ApplicationStages.SETUP) {
        stage = ApplicationStages.APPLY
    }

    const UploadSections = useMemo(() => {
        if (mortgage) {
            const application = APPLICATION()
            const preApproved = PREAPPROVAL()
            const approved = APPROVAL()


            const uploadSections = [...application, ...preApproved, ...approved]
            // replace the U:* defaultUserStages with the actual stages, if they pass the incomplete/upload date test
            uploadSections.forEach(section => {
                if (section.defaultUserStages?.length) {
                    section.defaultUserStages = section.defaultUserStages.map(stage => {
                        if (stage.startsWith('U:')) {
                            const actualStage = stage.replace('U:', '')
                            if (isSectionIncompleteOrHasUploadsNewerThenLastPackage(mortgage.applicationStage, section)) {
                                return actualStage
                            }
                            return null
                        }
                        return stage
                    }).filter(it => !!it)
                }
            })

            return uploadSections.filter(section => {

                return !(section.props.redundant && !section.activeUploads.length);
            })
        }

        return []
    }, [mortgage])

    const sectionsWithUserComplete = UploadSections.filter(section => section.isActive && section.progress?.isUserComplete)

    /*
         The task: Customer uploads something, then recieves a thanks email with a list of outstanding uploads

         -detect when an upload has changed from Pending to something else
         -when that happens, this customer needs to receive (delayed) automated email showing what's still outstanding
         -but the list of what's still outstanding will be incomplete until admin inputs the data from the new uploads

         -so now we need to detect when admin has finished working on the uploads and when that happens, generate the outstanding email and save it to the db to be sent after 3 hrs

         -if the customer uploads something else in the mean time, the automated email should be cancelled and a new one created will be created when admin deals with the new uploads



         -when admin has finished inputting all the data a queued email should be created in the db with the list of outstanding uploads as the body





     */
    useEffect(() => {

        // DO SECTION AUTOMATIONS
        if (mortgageUploadSectionsTimout) {
            clearTimeout(mortgageUploadSectionsTimout);
        }
        if ([ApplicationStatuses.ACTIVE, ApplicationStatuses.DELAYED].includes(mortgage.applicationStatus)) {
            mortgageUploadSectionsTimout = setTimeout(async () => {

                const automations = UploadSections.flatMap(section => section.getAutomations ? section.getAutomations() : [])

                const update = automations.map(a => a.update).filter(it => !!it)


                // Update docs complete in APproval Stage
                let allComplete = UploadSections.filter(it => it.isActive && it.stage === 'APPROVED').every(it => it.isComplete)
                const key = 'allCustomerClosingDocsComplete'
                if (allComplete) {
                    if (mortgage?.activeSubmission?.completedFlowItemsForAdmin && !mortgage?.activeSubmission?.completedFlowItemsForAdmin?.hasOwnProperty(key)) {

                        update.push(mortgage.completedFlowItemsForAdmin.getMarkCompleteUpdateMutation(key, mortgage.activeSubmission?.id))
                    }
                } else {
                    if (mortgage?.activeSubmission?.completedFlowItemsForAdmin && mortgage?.activeSubmission?.completedFlowItemsForAdmin?.hasOwnProperty(key)) {

                        update.push(mortgage.completedFlowItemsForAdmin.getMarkCompleteUpdateMutationUndo(key, mortgage.activeSubmission?.id))
                    }
                }
                // if (stage === "APPROVAL" && mortgage.applicationStatus === "ACTIVE") {
                //     const allCustomerClosingDocsComplete = 'allCustomerClosingDocsComplete';
                //     const incompleteSections = UploadSections.filter(s => s.stage === stage && !s.isComplete && s.isActive);
                //     console.log(allCustomerClosingDocsComplete);
                //     if (incompleteSections.length === 0) {
                //
                //         if (!mortgage.activeSubmission.completedFlowItemsForAdmin.hasOwnProperty(allCustomerClosingDocsComplete)) {
                //             console.log('updating allCustomerClosingDocsComplete to complete')
                //             update.push(mortgage.completedFlowItemsForAdmin.getMarkCompleteUpdateMutation(allCustomerClosingDocsComplete, mortgage.activeSubmission?.id))
                //             // const update = completedFlowItemsForAdmin.getMarkCompleteUpdateMutation(allCustomerClosingDocsComplete, activeSubmission?.id);
                //             // console.log({update})
                //             // mutate({update})
                //         }
                //         else{
                //             console.log('approval uploads already marked complete')
                //         }
                //     } else {
                //         if (mortgage.activeSubmission.completedFlowItemsForAdmin.hasOwnProperty(allCustomerClosingDocsComplete)) {
                //             console.log('updating allCustomerClosingDocsComplete to complete')
                //             update.push(mortgage.completedFlowItemsForAdmin.getMarkCompleteUpdateMutationUndo(allCustomerClosingDocsComplete, mortgage.activeSubmission?.id));
                //             // console.log({update})
                //             // mutate({update})
                //         }
                //         else{
                //             console.log('approval uploads already marked incomplete')
                //         }
                //     }
                // }

                if (!update.length) {
                    console.log('NO AUTOMATIONS TO RUN')
                    return
                }

                await mortgage.mutate({update})
            }, 2000);
        }
        return () => {
            if (mortgageUploadSectionsTimout) {
                clearTimeout(mortgageUploadSectionsTimout);
            }
        }
    }, [UploadSections]);

    return UploadSections
}

export default useMortgageUploadSections;